module.exports = __webpack_public_path__ + "img/3942129a1ac0e8e6dc9f202a801616cf.svg";